export default (node) => {
  const allTabs = node.querySelectorAll('[data-tab]');
  const allTabsContent = document.querySelectorAll('.data-tab-content');

  const changeTab = (e) => {
    allTabs.forEach((tab) => {
      tab.classList.remove('tab-current');
    });

    allTabsContent.forEach((content) => {
      content.classList.add('hidden');
    });

    const tab = e.currentTarget;
    tab.classList.add('tab-current');

    allTabsContent.forEach((content) => {
      const allClasses = content.classList;
      if (allClasses.contains(`data-tab-content-${tab.dataset.tab}`)) {
        content.classList.remove('hidden');
      }
    });
  };

  const init = async () => {
    allTabs.forEach((tab) => {
      tab.addEventListener('click', changeTab);
    });
  };

  init();
};
